import { createFileRoute } from '@tanstack/react-router';
import RefundOptions from '../../../../../components/RefundOptions';

import { EClaimType } from '../../../../../lib/types';
import { TLanguage } from '@/components/ui/language-picker';
import { EntityType } from '../../../../../services/direct';

export interface ISearchParams {
  claimType?: EClaimType;
  paymentType?: string;
  step: number;
  language?: TLanguage;
  entityType?: EntityType;
}

export const Route = createFileRoute(
  '/payments/_authenticated/_layouts/payment-methods/',
)({
  component: PaymentMethods,
  validateSearch: (searchParams: Record<string, unknown>): ISearchParams => {
    return {
      claimType: (searchParams.claimType as EClaimType) ?? 'Email',
      paymentType: searchParams.paymentType as string,
      step: searchParams.step ? +searchParams.step : 0,
      language: searchParams.language as TLanguage,
      entityType: Object.values(EntityType).includes(
        searchParams.entityType as EntityType,
      )
        ? (searchParams.entityType as EntityType)
        : undefined,
    };
  },
});

function PaymentMethods() {
  return <RefundOptions />;
}
